import {ValidatorConstraint, ValidatorConstraintInterface, ValidationArguments} from "class-validator";

function stripHtml(html) {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return (tmp.textContent || tmp.innerText || "").trim();
}

@ValidatorConstraint({ name: "customText", async: false })
export class MceValidator implements ValidatorConstraintInterface {

    validate(text: string, args: ValidationArguments) {
        if (!text) {
            return null;
        }

        return stripHtml(text).length > 0;
    }

    defaultMessage(args: ValidationArguments) { // here you can provide default error message if validation failed
        return "This field is required";
    }

}
